<template>
  <div class="tabs__item item_3 tabs__paged__container">
    <div class="tabs__paged">
      <div class="tab__content">
        <div class="tab__content__title">
          <p class="tab__content__title_large">{{ $t("designTab.bigHeading") }}</p>
        </div>
      </div>
      <div class="tabs__row">
        <div class="tab__content">
          <div class="tab__active__title">
            {{ $t("designTab.sectionButtonTemplatesHeading") }}
          </div>
          <div class="tabs__input_hidden_radio">
            <div>
              <div :class="config.buttonClass == 'orange' ? 'selected' : ''">
                <div class="template-button orange" @click="setClass" data-class="orange">
                  {{ $t("designTab.buttonPayDefaultText") }}
                </div>
              </div>
              <div :class="config.buttonClass == 'blue' ? 'selected' : ''">
                <div class="template-button blue" @click="setClass" data-class="blue">
                  {{ $t("designTab.buttonPayDefaultText") }}
                </div>
              </div>
              <div :class="config.buttonClass == 'purple' ? 'selected' : ''">
                <div class="template-button purple" @click="setClass" data-class="purple">
                  {{ $t("designTab.buttonPayDefaultText") }}
                </div>
              </div>
            </div>
            <div>
              <div :class="config.buttonClass == 'green' ? 'selected' : ''">
                <div class="template-button green" @click="setClass" data-class="green">
                  {{ $t("designTab.buttonPayDefaultText") }}
                </div>
              </div>
              <div :class="config.buttonClass == 'red' ? 'selected' : ''">
                <div class="template-button red" @click="setClass" data-class="red">
                  {{ $t("designTab.buttonPayDefaultText") }}
                </div>
              </div>
              <div :class="config.buttonClass == 'light' ? 'selected' : ''">
                <div class="template-button light" @click="setClass" data-class="light">
                  {{ $t("designTab.buttonPayDefaultText") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tabs__row">
        <div class="tab__content">
          <div class="tab__active__title">
            {{ $t("designTab.sectionButtonTextHeading") }}
          </div>
          <div class="tabs__input_text">
            <input
              id="text"
              v-on:change="ax"
              v-on:keyup="checkError"
              v-on:keypress="checkEnter"
              maxLength="30"
              autocomplete="off"
              type="text"
              :placeholder="$t('designTab.inputButtonTextPlaceholder')"
              :value="config.buttonText">
            <span class="error-msg">{{ $t("errors.maxlength") }}</span>
            <span style="display: none" class="check-mark"></span>
          </div>
        </div>
      </div>
      <div class="tabs__row">
        <div class="tab__content">
          <div class="tab__active__title_checkbox">
            <span>
              <input
                @click="ax"
                type="checkbox"
                class="styled-checkbox"
                name="paypal2"
                id="paypal2"
                :checked="config.paypal2 == 1"
                value="paypal2"
              >
              <label class="input__variant" for="paypal2">{{ $t("designTab.labelPaypalIcon") }}</label>
            </span>
            <img src="../assets/img/paypal.svg" alt>
          </div>
        </div>
      </div>
      <!--
      <div class="tabs__row">
        <div class="tab__content">
          <div class="tab__active__title_checkbox">
            <span>
              <input
                @click="ax"
                value="wixColor"
                type="checkbox"
                class="styled-checkbox"
                name="wixColor"
                id="wixColor"
                :checked="config.wixColor == 1"
              >
              <label class="input__variant" for="wixColor">{{ $t("designTab.useWixColorSheme") }}</label>
            </span>
          </div>
        </div>
      </div>
      -->
      <div class="tabs__row">
        <div class="tab__content">
          <div class="tab__active__title">
            {{ $t("designTab.sectionCreditCardIconsHeading") }}
            <span class="info__box"><span>{{ $t("designTab.sectionCreditCardIconsClarification") }}</span></span>
          </div>
          <div class="tabs__input_checkbox">
            <p class="tabs__input__variants_ch">
              <span>
                <input
                  type="checkbox"
                  class="styled-checkbox"
                  id="ae"
                  name="ae"
                  ref="americanExpress"
                  :checked="config.ae == 1"
                  @click="ax"
                >
                <label class="input__variant" for="ae">American Express</label>
              </span>
              <img src="../assets/img/american-express-dark_x2.svg" alt>
            </p>
            <p class="tabs__input__variants_ch">
              <span>
                <input
                  type="checkbox"
                  class="styled-checkbox"
                  id="dis"
                  name="dis"
                  value="dis"
                  ref="discover"
                  :checked="config.dis == 1"
                  @click="ax"
                >
                <label class="input__variant" for="dis">Discover</label>
              </span>
              <img src="../assets/img/discover-dark_x2.svg" alt>
            </p>
            <p class="tabs__input__variants_ch">
              <span>
                <input
                  type="checkbox"
                  class="styled-checkbox"
                  id="visa"
                  name="visa"
                  value="visa"
                  ref="Visa"
                  :checked="config.visa == 1"
                  @click="ax"
                >
                <label class="input__variant" for="visa">Visa</label>
              </span>
              <img src="../assets/img/visa-dark_x2.svg" alt>
            </p>
            <p class="tabs__input__variants_ch">
              <span>
                <input
                  type="checkbox"
                  class="styled-checkbox"
                  id="mc"
                  name="mc"
                  value="mc"
                  ref="masterCard"
                  :checked="config.mc == 1"
                  @click="ax"
                >
                <label class="input__variant" for="mc">Master Card</label>
              </span>
              <img src="../assets/img/master-card-dark_x2.svg" alt>
            </p>
            <p class="tabs__input__variants_ch">
              <span>
                <input
                  type="checkbox"
                  class="styled-checkbox"
                  id="paypal"
                  value="paypal"
                  name="paypal"
                  ref="payPal"
                  :checked="config.paypal == 1"
                  @click="ax"
                >
                <label class="input__variant" for="paypal">PayPal</label>
              </span>
              <img src="../assets/img/paypal-light_x2.svg" alt>
            </p>
          </div>
        </div>
      </div>
      <div class="tabs__row">
        <div class="tab__content">
          <div class="tabs__input_arrow" @click="switchToAdvanced">
            {{ $t("designTab.sectionAdvancedDesignHeading") }}
          </div>
        </div>
      </div>
      <div class="tabs__row last">
        <div class="tab__content">
          <div class="tabs__input_text_reset">
            {{ $t("designTab.sectionResetHeading") }}
            <button id="reset" class="button_reset" @click="ax" value="reset">
              {{ $t("designTab.buttonReset") }}
              </button>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs__paged">
      <div class="tab__content">
        <div class="tab__content__title">
          <div class="arrow-button backward-button" @click="switchToAdvanced">{{ $t("general.buttonBackward") }}</div>
          <p class="tab__content__title_large">{{ $t("designTab.bigHeading") }}</p>
        </div>
      </div>
      <div class="tabs__row last">
        <div class="tab__content">
          <div class="tab__active__title">
            {{ $t("designTab.sectionAdvancedDesignHeading") }}
          </div>
          <div class="tabs__input_field">
            <div>
              <div class="field__title" style="width: 70%">{{ $t("designTab.sectionFontFamilyHeading") }}</div>
              <div class="field__title" style="width: 23%">{{ $t("designTab.sectionFontSizeHeading") }}</div>
            </div>
            <div>
              <div class="tabs__input_select input__select" style="width: 70%">
                <select name="fontFamily" id="fontFamily" v-on:change="ax">
                  <option data-style="font-family: AdobeCaslonW01-SmBd" value="AdobeCaslonW01-SmBd">Adobe Caslon</option>
                  <option data-style="font-family: Almoni DL AAA" value="Almoni DL AAA">Almoni DL AAA</option>
                  <option data-style="font-family: Amatic SC" value="Amatic SC">Amatic SC</option>
                  <option data-style="font-family: Amiri" value="Amiri">Amiri</option>
                  <option data-style="font-family: Anton" value="Anton">Anton</option>
                  <option data-style="font-family: Apple SD Gothic Neo" value="Apple SD Gothic Neo">Apple SD Gothic Neo</option>
                  <option data-style="font-family: Arial" value="Arial">Arial</option>
                  <option data-style="font-family: Arial black" value="Arial black">Arial black</option>
                  <option data-style="font-family: ArianLT-Light" value="ArianLT-Light">Arian Light</option>
                  <option data-style="font-family: August Bold" value="August Bold">August Bold</option>
                  <option data-style="font-family: August Light" value="August Light">August Light</option>
                  <option data-style="font-family: AvenidaW01" value="AvenidaW01">Avenida</option>
                  <option data-style="font-family: Avenir" value="Avenir">Avenir</option>
                  <option data-style="font-family: Barlow" value="Barlow">Barlow</option>
                  <option data-style="font-family: BaskervilleMTW01-SmBdIt" value="BaskervilleMTW01-SmBdIt">Baskerville</option>
                  <option data-style="font-family: Basic" value="Basic">Basic</option>
                  <option data-style="font-family: BelindaW00-Regular" value="BelindaW00-Regular">Belinda</option>
                  <option data-style="font-family: Bodoni" value="Bodoni">Bodoni</option>
                  <option data-style="font-family: Bookman" value="Bookman">Bookman</option>
                  <option data-style="font-family: BraggadocioW01" value="BraggadocioW01">Braggadocio</option>
                  <option data-style="font-family: BrandonGrotW01-Light" value="BrandonGrotW01-Light">Brandon Grot Light</option>
                  <option data-style="font-family: BreeW01-ThinOblique" value="BreeW01-ThinOblique">Bree</option>
                  <option data-style="font-family: Calibri" value="Calibri">Calibri</option>
                  <option data-style="font-family: Candara" value="Candara">Candara</option>
                  <option data-style="font-family: Caudex" value="Caudex">Caudex</option>
                  <option data-style="font-family: Chelsea Market" value="Chelsea Market">Chelsea Market</option>
                  <option data-style="font-family: Cinzel" value="Cinzel">Cinzel</option>
                  <option data-style="font-family: ClarendonW01-Medium" value="ClarendonW01-Medium">Clarendon</option>
                  <option data-style="font-family: Comic Sans MS" value="Comic Sans MS">Comic Sans MS</option>
                  <option data-style="font-family: Cookie" value="Cookie">Cookie</option>
                  <option data-style="font-family: CoquetteW00-Light" value="CoquetteW00-Light">Coquette Light</option>
                  <option data-style="font-family: Corben" value="Corben">Corben</option>
                  <option data-style="font-family: Courier New" value="Courier New">Courier New</option>
                  <option data-style="font-family: DidoteTextW01-Italic" value="DidoteTextW01-Italic">Didot eText Italic</option>
                  <option data-style="font-family: DINNeuzeitGroteskLTW01-BdCn" value="DINNeuzeitGroteskLTW01-BdCn">DIN Neuzeit Grotesk</option>
                  <option data-style="font-family: DINNextW01-Light" value="DINNextW01-Light">DIN Next</option>
                  <option data-style="font-family: DroidSerifW01-Regular" value="DroidSerifW01-Regular">Droid Serif</option>
                  <option data-style="font-family: EB Garamond" value="EB Garamond">EB Garamond</option>
                  <option data-style="font-family: Enriqueta" value="Enriqueta">Enriqueta</option>
                  <option data-style="font-family: Fredericka the Great" value="Fredericka the Great">Fredericka the Great</option>
                  <option data-style="font-family: Forum" value="Forum">Forum</option>
                  <option data-style="font-family: FuturaLTW01-Bold" value="FuturaLTW01-Bold">Futura</option>
                  <option data-style="font-family: Garamond" value="Garamond">Garamond</option>
                  <option data-style="font-family: Georgia" value="Georgia">Georgia</option>
                  <option data-style="font-family: GeoticaW01-Four" value="GeoticaW01-Four">Geotica</option>
                  <option data-style="font-family: Helvetica" value="Helvetica">Helvetica</option>
                  <option data-style="font-family: Impact" value="Impact">Impact</option>
                  <option data-style="font-family: Janna LT Regular" value="Janna LT Regular">Janna LT Regular</option>
                  <option data-style="font-family: Jockey One" value="Jockey One">Jockey One</option>
                  <option data-style="font-family: Josefin Slab" value="Josefin Slab">Josefin Slab</option>
                  <option data-style="font-family: Jura" value="Jura">Jura</option>
                  <option data-style="font-family: Kelly Slab" value="Kelly Slab">Kelly Slab</option>
                  <option data-style="font-family: Lato" value="Lato">Lato</option>
                  <option data-style="font-family: Libre Baskerville" value="Libre Baskerville">Libre Baskerville</option>
                  <option data-style="font-family: Lobster" value="Lobster">Lobster</option>
                  <option data-style="font-family: Lucida Console" value="Lucida Console">Lucida Console</option>
                  <option data-style="font-family: LuloCleanW01-OneBold" value="LuloCleanW01-OneBold">Lulo Clean Bold</option>
                  <option data-style="font-family: MarzoW00-Regular" value="MarzoW00-Regular">Marzo Regular</option>
                  <option data-style="font-family: Montserrat" value="Montserrat">Montserrat</option>
                  <option data-style="font-family: MuseoW01-700" value="MuseoW01-700">Museo</option>
                  <option data-style="font-family: Niconne" value="Niconne">Niconne</option>
                  <option data-style="font-family: NimbusSanTW01Con" value="NimbusSanTW01Con">Nimbus Sans</option>
                  <option data-style="font-family: Noticia Text" value="Noticia Text">Noticia Text</option>
                  <option data-style="font-family: OpenSans" value="OpenSans">OpenSans</option>
                  <option data-style="font-family: Open Sans Condensed" value="Open Sans Condensed">Open Sans Condensed</option>
                  <option data-style="font-family: Oswald" value="Oswald">Oswald</option>
                  <option data-style="font-family: Overlock" value="Overlock">Overlock</option>
                  <option data-style="font-family: Pacifica" value="Pacifica">Pacifica</option>
                  <option data-style="font-family: Palatino" value="Palatino">Palatino</option>
                  <option data-style="font-family: Play" value="Play">Play</option>
                  <option data-style="font-family: Patrick Hand" value="Patrick Hand">Patrick Hand</option>
                  <option data-style="font-family: Playfair Display" value="Playfair Display">Playfair Display</option>
                  <option data-style="font-family: Poppins" value="Poppins">Poppins</option>
                  <option data-style="font-family: ProximaNW01-Reg" value="ProximaNW01-Reg">Proxima</option>
                  <option data-style="font-family: Raleway" value="Raleway">Raleway</option>
                  <option data-style="font-family: ReklameScriptW00-Medium" value="ReklameScriptW00-Medium">Reklame Script Medium</option>
                  <option data-style="font-family: Roboto" value="Roboto">Roboto</option>
                  <option data-style="font-family: Sail" value="Sail">Sail</option>
                  <option data-style="font-family: SalesforceSans" value="SalesforceSans">SalesforceSans</option>
                  <option data-style="font-family: Signika" value="Signika">Signika</option>
                  <option data-style="font-family: SnellRoundhandW01-Script" value="SnellRoundhandW01-Script">Snell Roundhand Script</option>
                  <option data-style="font-family: Soho" value="Soho">Soho</option>
                  <option data-style="font-family: SourceSansPro" value="SourceSansPro">SourceSansPro</option>
                  <option data-style="font-family: Spinnaker" value="Spinnaker">Spinnaker</option>
                  <option data-style="font-family: StencilW01-Bold" value="StencilW01-Bold">Stencil Bold</option>
                  <option data-style="font-family: Suez One" value="Suez One">Suez One</option>
                  <option data-style="font-family: Tahoma" value="Tahoma">Tahoma</option>
                  <option data-style="font-family: Times New Roman" value="Times New Roman">Times New Roman</option>
                  <option data-style="font-family: TrendSansW00-Four" value="TrendSansW00-Four">TrendSans</option>
                  <option data-style="font-family: Verdana" value="Verdana">Verdana</option>
                </select>
                <div class="select-selected">{{ config.fontFamily }}</div>
              </div>
              <div class="tabs__input_select input__select" style="width: 23%">
                <select name="fontSize" id="fontSize" v-on:change="ax">
                  <option value="8">8 px</option>
                  <option value="9">9 px</option>
                  <option value="10">10 px</option>
                  <option value="11">11 px</option>
                  <option value="12">12 px</option>
                  <option value="13">13 px</option>
                  <option value="14">14 px</option>
                  <option value="15">15 px</option>
                  <option value="16">16 px</option>
                  <option value="17">17 px</option>
                  <option value="18">18 px</option>
                  <option value="19">19 px</option>
                  <option value="20">20 px</option>
                  <option value="21">21 px</option>
                  <option value="22">22 px</option>
                  <option value="23">23 px</option>
                  <option value="24">24 px</option>
                  <option value="25">25 px</option>
                  <option value="26">26 px</option>
                  <option value="27">27 px</option>
                  <option value="28">28 px</option>
                  <option value="29">29 px</option>
                  <option value="30">30 px</option>
                  <option value="31">31 px</option>
                  <option value="32">32 px</option>
                </select>
                <div class="select-selected">{{ config.fontSize }} px</div>
              </div>
            </div>
            <div>
              <div class="field__title" style="width: 20%">{{ $t("designTab.sectionTextColorHeading") }}</div>
              <div class="field__title" style="width: 20%">{{ $t("designTab.sectionMainColorHeading") }}</div>
              <div class="field__title" style="width: 20%">{{ $t("designTab.sectionMainColor2Heading") }}</div>
              <div class="field__title" style="width: 20%">{{ $t("designTab.sectionBorderColorHeading") }}</div>
            </div>
            <div>
              <div class="tabs__input_select input__select" style="width: 20%">
                <div class="select__like__input color__input" @click="textColorShow = 1">
                  <span v-bind:style="{'background-color': config.textColor}"></span>
                </div>
                <div class="tabs__popup__input" v-show="textColorShow == 1">
                  <v-color-picker hide-mode-switch="false" mode="rgba" :value="config.textColor" id="textColor" @input="onTextColorChange"></v-color-picker>
                  <div class="button_blue button_big" @click="setColor" data-name="textColor" id="textColorShow">OK</div>
                </div>
              </div>
              <div class="tabs__input_select input__select" style="width: 20%">
                <div class="select__like__input color__input" @click="mainColorShow = 1">
                  <span v-bind:style="{'background-color': config.mainColor}"></span>
                </div>
                <div class="tabs__popup__input" v-show="mainColorShow == 1">
                  <v-color-picker hide-mode-switch="false" mode="rgba" :value="config.mainColor" id="mainColor" @input="onMainColorChange"></v-color-picker>
                  <div class="button_blue button_big" @click="setColor" data-name="mainColor" id="mainColorShow">OK</div>
                </div>
              </div>
              <div class="tabs__input_select input__select" style="width: 20%">
                <div class="select__like__input color__input" @click="mainColor2Show = 1">
                  <span v-bind:style="{'background-color': config.mainColor2}"></span>
                </div>
                <div class="tabs__popup__input" v-show="mainColor2Show == 1">
                  <v-color-picker hide-mode-switch="false" mode="rgba" :value="config.mainColor2" id="mainColor2" @input="onMainColor2Change"></v-color-picker>
                  <div class="button_blue button_big" @click="setColor" data-name="mainColor2" id="mainColor2Show">OK</div>
                </div>
              </div>
              <div class="tabs__input_select input__select" style="width: 20%">
                <div class="select__like__input color__input" @click="borderColorShow = 1">
                  <span v-bind:style="{'background-color': config.borderColor}"></span>
                </div>
                <div class="tabs__popup__input" v-show="borderColorShow == 1">
                  <v-color-picker hide-mode-switch="false" mode="rgba" :value="config.borderColor" id="borderColor" @input="onBorderColorChange"></v-color-picker>
                  <div class="button_blue button_big" @click="setColor" data-name="borderColor" id="borderColorShow">OK</div>
                </div>
              </div>
            </div>
            <!--
            <div class="flex-hstart">
              <div class="tabs__input_select input__select" style="width: 28%; margin: 0 8%">
                <div class="select__like__input color__input" @click="shadowColorShow = 1">
                  <span v-bind:style="{'background-color': config.shadowColor}"></span>
                </div>
                <div class="tabs__popup__input" v-show="shadowColorShow == 1">
                  <v-color-picker hide-mode-switch="false" mode="rgba" :value="config.shadowColor" id="shadowColor" @input="onShadowColorChange"></v-color-picker>
                  <div class="button_blue button_big" @click="setColor" data-name="shadowColor" id="shadowColorShow">OK</div>
                </div>
              </div>
            </div>
            -->
            <div>
              <div class="field__title" style="width: 20%">{{ $t("designTab.sectionBorderSizeHeading") }}</div>
            </div>
            <div>
              <v-slider
                id="borderSize"
                style="max-width: 75%"
                :value="config.borderSize"
                color="#828da4"
                height="8"
                min="0"
                max="32"
                thumb-color="#fff"
                thumb-size="20px"
                track-color="rgba(14, 49, 94, 0.2)"
                track-fill-color="#0e315e"
                @input="onBorderSizeChange"
                @change="setBorderSize"
              ></v-slider>
              <div class="tabs__input_text" style="width: 20%">
                <input type="text" readonly autocomplete="off" style="text-align: center" :value="borderSize">
              </div>
            </div>
            <div>
              <div class="field__title" style="width: 20%">{{ $t("designTab.sectionBorderRadiusHeading") }}</div>
            </div>
            <div>
              <v-slider
                id="borderRound"
                style="max-width: 75%"
                :value="config.borderRound"
                color="#828da4"
                height="8"
                min="0"
                max="16"
                thumb-color="#fff"
                thumb-size="20px"
                track-color="rgba(14, 49, 94, 0.2)"
                track-fill-color="#0e315e"
                @input="onBorderRoundChange"
                @change="setBorderRound"
              ></v-slider>
              <div class="tabs__input_text" style="width: 20%">
                <input type="text" readonly autocomplete="off" style="text-align: center" :value="borderRound">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="tabs__banner">
      <div class="banner2__container">
        <header>{{ $t("banners.banner2Header") }}</header>
        <div class="__mask"></div>
        <div class="__list">
          <ul>
            <li>{{ $t("banners.banner2List_1") }}</li>
            <li>{{ $t("banners.banner2List_2") }}</li>
            <li>{{ $t("banners.banner2List_3") }}</li>
          </ul>
          <ul>
            <li>{{ $t("banners.banner2List_4") }}</li>
            <li>{{ $t("banners.banner2List_5") }}</li>
          </ul>
        </div>
        <footer>
          <a href="#" @click="openUpgradePage">{{ $t("banners.learnMore") }}</a>
        </footer>
      </div>
    </div>
    -->
  </div>
</template>

<script>
// import lang from '../../config'
import * as Helpers from '@/assets/js/helpers.js'
import * as GA from '@/assets/js/ga.js'

export default {
  name: 'tabDesign',
  props: ['loggedIn', 'pivotId', 'config', 'userData', 'instanceId'],
  data () {
    return {
      langs: ['en', 'ru'],
      textColorShow: 0,
      mainColorShow: 0,
      mainColor2Show: 0,
      borderColorShow: 0,
      shadowColorShow: 0,
      textColor: '',
      mainColor: '',
      mainColor2: '',
      borderColor: '',
      shadowColor: '',
      borderSize: 0,
      borderRound: 0
    }
  },
  methods: {
    ax (event) {
      if (
        event.target.id === 'ae' || event.target.id === 'dis' || event.target.id === 'paypal' ||
        event.target.id === 'visa' || event.target.id === 'mc' || event.target.id === 'paypal2' ||
        event.target.id === 'wixColor') {
        const d = {}
        d[event.target.id] = event.target.checked
        this.$emit('changeDesign', d)
      } else if (event.target.id === 'text') {
        event.target.setAttribute('data-valid', true)
        const elem = event.target

        window.setTimeout(function () {
          elem.removeAttribute('data-valid')
        }, 2000)

        this.$emit('changeDesign', { 'buttonText': event.target.value })
      } else if (this.config[event.target.id] !== undefined) {
        const d = {}
        d[event.target.id] = event.target.value
        this.$emit('changeDesign', d)
      } else if (event.target.id === 'reset') {
        this.$emit('changeDesign', { 'reset': 'true' })
      }
    },
    checkEnter: function (event) {
      if (event.keyCode === 13) {
        this.ax(event)
        event.target.blur()
      }
    },
    checkError: function (event) {
      const all = document.querySelectorAll('.input-error')
      for (let i = 0; i < all.length; i++) all[i].classList.remove('input-error')
      const max = parseInt(event.target.maxLength)

      if (!isNaN(max) && event.target.value.length === max) {
        event.target.classList.add('input-error')

        GA.track('wixpay_error_show', {
          uid: this.loggedIn ? this.userData.business_id : null,
          page: 'Design',
          error_name: 'button_text_maxlength_exceeded'
        })
      } else event.target.classList.remove('input-error')

      if (event.target.id === 'text') {
        const dt = Helpers.parseJSON(localStorage.getItem('vc_design_cfg_' + this.$wixInstanceId))

        if (dt !== null) {
          dt.buttonText = event.target.value

          if (event.target.value.length === 0) {
            dt.buttonText = this.$i18n.t('designTab.buttonPayDefaultText')
          }

          localStorage.setItem('vc_design_cfg_' + this.$wixInstanceId, JSON.stringify(dt))
        }
      }
    },
    setClass: function (event) {
      const n = event.target.getAttribute('data-class')
      const d = {}
      d['buttonClass'] = n

      if (n === 'orange') {
        d['fontFamily'] = 'Montserrat'
        d['fontSize'] = 16
        d['shadowColor'] = '#00000080'
        d['mainColor'] = '#ffcd00'
        d['mainColor2'] = '#ff9f00'
        d['textColor'] = '#ffffff'
        d['borderColor'] = '#ffcd00'
        d['borderSize'] = 0
        d['borderRound'] = 8
      } else if (n === 'blue') {
        d['fontFamily'] = 'Montserrat'
        d['fontSize'] = 16
        d['shadowColor'] = '#fff0'
        d['mainColor'] = '#00aeff'
        d['mainColor2'] = '#0076ff'
        d['textColor'] = '#ffffff'
        d['borderColor'] = '#00aeff'
        d['borderSize'] = 0
        d['borderRound'] = 0
      } else if (n === 'purple') {
        d['fontFamily'] = 'Montserrat'
        d['fontSize'] = 16
        d['shadowColor'] = '#fff0'
        d['mainColor'] = '#bb88e9'
        d['mainColor2'] = '#8550ce'
        d['textColor'] = '#ffffff'
        d['borderColor'] = '#bb88e9'
        d['borderSize'] = 0
        d['borderRound'] = 32
      } else if (n === 'green') {
        d['fontFamily'] = 'Montserrat'
        d['fontSize'] = 16
        d['shadowColor'] = '#fff0'
        d['mainColor'] = '#21eaaf'
        d['mainColor2'] = '#21eaaf'
        d['textColor'] = '#ffffff'
        d['borderColor'] = '#21eaaf'
        d['borderSize'] = 0
        d['borderRound'] = 0
      } else if (n === 'red') {
        d['fontFamily'] = 'Montserrat'
        d['fontSize'] = 16
        d['shadowColor'] = '#fff0'
        d['mainColor'] = '#ff7d70'
        d['mainColor2'] = '#ff7d70'
        d['textColor'] = '#ffffff'
        d['borderColor'] = '#cc304f'
        d['borderSize'] = 1
        d['borderRound'] = 4
      } else if (n === 'light') {
        d['fontFamily'] = 'Montserrat'
        d['fontSize'] = 16
        d['shadowColor'] = '#fff0'
        d['mainColor'] = '#ffffff'
        d['mainColor2'] = '#ffffff'
        d['textColor'] = '#0090ff'
        d['borderColor'] = '#0090ff'
        d['borderSize'] = 1
        d['borderRound'] = 4
      }

      for (let i in d) if (this[i] !== undefined) this[i] = d[i]
      this.$emit('changeDesign', d)

      GA.track('wixpay_change_template', {
        uid: this.loggedIn ? this.userData.business_id : null
      })
    },
    setColor: function (event) {
      const n = event.target.getAttribute('data-name')
      this[event.target.id] = 0
      if (this[n] === undefined) return
      const d = {}
      d[n] = this[n]
      d['buttonClass'] = 'usrdefined'
      this.$emit('changeDesign', d)
    },
    setBorderSize: function (e) {
      const d = {}
      d['borderSize'] = e
      d['buttonClass'] = 'usrdefined'
      this.$emit('changeDesign', d)
    },
    setBorderRound: function (e) {
      const d = {}
      d['borderRound'] = e
      d['buttonClass'] = 'usrdefined'
      this.$emit('changeDesign', d)
    },
    switchToAdvanced: function () {
      const e = document.querySelector('.tabs__paged')
      if (e !== null) e.classList.toggle('slided')

      GA.track('wixpay_advanced_design', {
        uid: this.loggedIn ? this.userData.business_id : null
      })
    },
    onTextColorChange: function (e) {
      this.onDesignChange('textColor', e)
    },
    onMainColorChange: function (e) {
      this.onDesignChange('mainColor', e)
    },
    onMainColor2Change: function (e) {
      this.onDesignChange('mainColor2', e)
    },
    onBorderColorChange: function (e) {
      this.onDesignChange('borderColor', e)
    },
    onShadowColorChange: function (e) {
      this.onDesignChange('shadowColor', e)
    },
    onBorderSizeChange: function (e) {
      this.onDesignChange('borderSize', e)
    },
    onBorderRoundChange: function (e) {
      this.onDesignChange('borderRound', e)
    },
    onDesignChange: function (id, val) {
      if (this[id] !== undefined) this[id] = val
      const dt = Helpers.parseJSON(localStorage.getItem('vc_design_cfg_' + this.$wixInstanceId))

      if (dt !== null) {
        dt[id] = val
        localStorage.setItem('vc_design_cfg_' + this.$wixInstanceId, JSON.stringify(dt))
      }
    },
    openUpgradePage: function () {
      this.$emit('openUpgradePage')
    }
  },
  created () {
    for (let i in this.config) {
      if (this[i] !== undefined) this[i] = this.config[i]
    }
  },
  mounted () {
    this.$ui.createSelects()
    const t = document.querySelector('.vue-tablist > li:nth-child(3)')

    if (t !== null) {
      t.addEventListener('click', function () {
        const e = document.querySelector('.tabs__paged')
        if (e !== null) e.classList.remove('slided')
      })
    }

    this.$emit('mounted', true)
  }
}
</script>
